export default __webpack_public_path__ + "static/media/One-To-Win-Game_Image.9ddf3816.png";